import { Resources, useResource } from "Infrastructure/Translations/Resources";
import {
  type InformationSection,
  InformationView,
} from "Shared/InformationView";
import { getFormattedValue, phoneMask } from "Shared/Utils/Format/object";

interface ClientInformationProps {
  companyNumber: string;
  taxNumber: string;
  email: string;
  phone: string;
  address?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  onEdit?: () => void;
}

export const ClientInformation = ({
  companyNumber,
  taxNumber,
  email,
  phone,
  address,
  city,
  postalCode,
  state,
  onEdit,
}: ClientInformationProps): React.ReactNode => {
  const { t } = useResource();

  const sections: InformationSection[] = [
    {
      items: [
        {
          label: t(Resources.Clients.ClientDetail.CompanyNumber),
          value: companyNumber,
        },
        {
          label: t(Resources.Clients.ClientDetail.TaxNumber),
          value: taxNumber,
        },
        { label: t(Resources.Clients.ClientDetail.Email), value: email },
        {
          label: t(Resources.Clients.ClientDetail.Phone),
          value: getFormattedValue(phone, undefined, phoneMask),
        },
        { label: t(Resources.Clients.ClientDetail.Address), value: address },
        { label: t(Resources.Clients.ClientDetail.City), value: city },
        {
          label: t(Resources.Clients.ClientDetail.PostalCode),
          value: postalCode,
        },
        { label: t(Resources.Clients.ClientDetail.State), value: state },
      ],
    },
  ];

  return (
    <InformationView
      title={t(Resources.Clients.ClientDetail.Information)}
      editLabel={t(Resources.Clients.ClientDetail.EditInformation)}
      onEdit={onEdit}
      sections={sections}
    />
  );
};
